import { render } from "./notify.vue?vue&type=template&id=2099c3a6&scoped=true"
import script from "./notify.vue?vue&type=script&lang=js"
export * from "./notify.vue?vue&type=script&lang=js"

import "./notify.vue?vue&type=style&index=0&id=2099c3a6&lang=scss&scoped=true"

import exportComponent from "D:\\Liyg\\jzwork\\view\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2099c3a6"]])

export default __exports__